export const PageTitle = ({ pageName }) => {
  return <h2 style={{ fontWeight: "bold" }}>{pageName}</h2>;
};
